/* ==========================================================================
   Searcher > Client > services
   ========================================================================== */
/* Modules */

const { getService } = require('../../../../../services/fetch');

const { validateDestination } = require('../validations');

const { ENDPOINTS } = require('../../../constants');

function buildChoices(instance, key, options) {
    const { config = {}, store = {} } = instance;
    const { literals = {} } = config;
    const { frequentPorts = '', otherPorts: otherPortsLiteral = '' } = literals;

    /* Data store */
    const { origin = {}, destination = {} } = store.select('data');

    const portCode = {
        origin: origin || '0',
        destination: destination || '0'
    }[key];

    const frecuentsPorts = {
        label: frequentPorts,
        id: 1,
        choices: options
            .filter(option => option.highlight)
            .map(option => {
                const { label = '', value } = option;
                const isSelected = value === portCode;
                return {
                    value,
                    label,
                    selected: isSelected
                };
            })
    };

    const otherPorts = {
        label: otherPortsLiteral,
        id: 2,
        choices: options
            .filter(option => !option.highlight)
            .map(option => {
                const { label = '', value } = option;
                const isSelected = value === portCode;

                return {
                    value,
                    label,
                    selected: isSelected
                };
            })
    };

    const choices =
        !frecuentsPorts.choices.length || !otherPorts.choices.length
            ? [...frecuentsPorts.choices, ...otherPorts.choices]
            : [
                  frecuentsPorts.choices.length > 0 ? { ...frecuentsPorts } : 0,
                  otherPorts.choices.length > 0 ? { ...otherPorts } : 0
              ];

    return {
        choices: choices.filter(item => item !== 0)
    };
}

function setSelectOptions(instance, key) {
    if (!instance[key]) return;

    const { config = {}, store = {} } = instance;
    const { endpoints = ENDPOINTS, application = 1, literals = {} } = config;
    const { ports = ENDPOINTS.ports } = endpoints;
    const { originDefault: originDefaultLiteral, destinationDefault: destinationDefaultLiteral } = literals;

    /* Data store */
    const { origin = {} } = store.select('data');

    /* Url origin param */
    const portCode = origin ? `&portCode=${origin}` : '';

    /* Build url's */
    const url = {
        origin: ports.concat('?', `application=${application}`),
        destination: ports.concat('?', `application=${application}`, portCode)
    };

    /* Add loading */
    instance[`${key}`].actions.toggleLoading();

    /* Subscription Fetch */
    getService(instance, url[`${key}`], key).subscribe({
        next: response => {
            const { origin: originValue = {}, destination: destinationValue } = store.select('data');

            /* API reponse data */
            const { error = false, locations = [] } = response;

            /* Remove loading */
            instance[`${key}`].actions.toggleLoading();

            /* Get ports or error */
            if (error || locations.length === 0) {
                /* Dispatch error */
                console.error('error', response);

                instance.actions.setError({ message: '', component: key });

                return;
            }

            /* Prepare Data choices */
            const choices = buildChoices(instance, key, locations);

            /* Dispatch: update select options */
            instance[key].actions.changeOptions(choices.choices);

            // sync Store destination
            if (key === 'destination' && destinationValue) {
                const choicesOptions = choices.choices.some(item => item.choices)
                    ? choices.choices.map(item => item.choices).reduce((a, b) => [...a, ...b])
                    : choices.choices;

                const hasPorCodeInChoices = choicesOptions.find(item => item.value === destinationValue);

                /* Change destination if a stored destination don't exist in new choices */
                if (!hasPorCodeInChoices) {
                    instance.actions.changeData({ destination: null });

                    validateDestination(instance);
                }
            }

            if (!destinationValue && destinationDefaultLiteral)
                instance.destination.input.actions.setValue(destinationDefaultLiteral);

            if (!originValue && originDefaultLiteral) instance.origin.input.actions.setValue(originDefaultLiteral);

            validateDestination(instance);
        },

        error: err => {
            /* Remove loading */
            instance[`${key}`].actions.toggleLoading();

            /* dispatch error */
            instance[key].actions.setError({ message: '', component: key });
            console.error('error results before subscription', err);
        }
    });
}

function setRoute(instance) {
    const { config = {}, store = {}, calendarInput } = instance;
    const { endpoints = ENDPOINTS, application = 1 } = config;
    const { route = ENDPOINTS.route } = endpoints;

    /* Data store */
    const { origin, destination, dates: storeDates, datesEnable = [] } = store.select('data');

    /* Build url */
    const url = route.concat(
        '?',
        `originPortCode=${origin}`,
        `&destinationPortCode=${destination}`,
        `&application=${application}`
    );

    /* Input loading */
    if (calendarInput) calendarInput.actions.toggleLoading();

    /* Subscription Fetch */
    getService(instance, url, 'route').subscribe({
        next: response => {
            const { dates: { disable = [], releaseDays = 2 } = {} } = config;
            const { error = false, data = {} } = response;

            // eslint-disable-next-line camelcase
            const { outbound_dates = [], return_dates = [], discounts = [], residents = [] } = data;

            /* Remove Input loading */
            if (calendarInput) calendarInput.actions.toggleLoading();

            /* Get ports or error */
            if (error) {
                console.error('error', response);

                /* We allow the user to select days even though we don't have operative */
                instance.actions.setData({
                    datesEnable: [],
                    route: { outboundDates: [], returnDates: [], discounts, residents }
                });

                return;
            }

            const disableDays = Array.isArray(disable) ? disable : [];

            /* prepare departure and return days */
            /* Merge departure days with disable days */
            const outboundDates = outbound_dates.filter(
                day => !disableDays.some(disableDay => disableDay === day.value)
            );

            const [startDate, endDate] = storeDates;

            if (disableDays.includes(startDate) || disableDays.includes(endDate)) {
                const initDate = datesEnable[0];
                const lastDate = datesEnable[0 + releaseDays];

                instance.actions.changeData({ dates: [initDate, lastDate] });
            }

            /* Merge departure days with disable days */
            const returnDates = return_dates.filter(day => !disableDays.some(disableDay => disableDay === day.value));

            /* Dispatch set data route, datesEnable */
            const discountsOptions = getDiscounts(instance, { discounts, residents });

            /* Sync data */
            instance.actions.changeData({
                datesEnable: outboundDates,
                route: { outboundDates, returnDates, discounts, residents },
                discounts: discountsOptions.discounts,
                bonus: discountsOptions.bonus
            });
        },
        error: err => {
            console.error('error results before subscription', err);

            /* dispatch error */
            instance.actions.setError({ message: '', component: undefined });
        }
    });
}

function getDiscounts(instance, data) {
    const { discounts: discountsStore = {}, bonus: bonusStore = {} } = instance.store.select('data');
    const { value: discountsValue = 0 } = discountsStore;
    const { value: bonusValue = 0 } = bonusStore;
    const { discounts = [], residents = [] } = data;

    return {
        discounts: residents
            .filter(item => item.type === discountsValue)
            .map(item => ({ label: item.name, value: item.type }))[0],
        bonus: discounts
            .filter(item => item.type === bonusValue)
            .map(item => ({ label: item.name, value: item.type }))[0]
    };
}

module.exports = {
    setSelectOptions,
    setRoute
};
